import http from "./base";
import axios from "axios";

export default {
    logout() {
        return axios.create().post('/logout')
    },
}
